import { Navigate } from "react-router-dom";
import { AppStorage } from "../../service/UserStorage";

export { PrivateRoute };

/**
 * @desc Sử dụng routing với quyền
 * @param children: elm con
 * @param role: quyền tương ứng
 * @param parentRole: Quyền này chứa các quyền con (thêm, sửa, xóa, ...) ở chung 1 routing
*/
const PrivateRoute = ({ children, role, parentRole }: { children: any; role: string; parentRole?: boolean }) => {
  let permissionString = AppStorage.get("pk");
  let permissions = JSON.parse(permissionString) || [];
  if ((!parentRole  && permissions.indexOf(role) < 0) || (parentRole && permissions.filter((t) => t.includes(role)).length == 0)) {
    return <Navigate to="/" />;
  }

  return children;
};
